import { inputCls, btn } from "./shared";

export const VariantTable = ({ variants, onChange, manual }) => {
  const update = (i, k, v) => onChange(variants.map((x, j) => (j === i ? { ...x, [k]: v } : x)));
  const setAllPrices = () => {
    const v = window.prompt("Set every option to this price (e.g. 32.00):");
    if (v && !Number.isNaN(Number(v))) onChange(variants.map((x) => ({ ...x, price: Number(v) })));
  };

  return (
    <div data-testid="admin-shop-variants">
      <div className="flex items-center justify-between mb-2">
        <p className="text-[10px] uppercase tracking-[0.25em] text-[#6D5A50]">Options & prices (what customers pay, USD)</p>
        <button type="button" className="text-xs underline text-[#4B3A2F]" onClick={setAllPrices} data-testid="admin-shop-set-all-prices">Set one price for all</button>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-[10px] uppercase tracking-[0.2em] text-[#8D7B6E]">
              <th className="py-1 pr-2">On sale</th><th className="pr-2">Option</th><th className="pr-2">Size</th><th className="pr-2">Color</th><th className="pr-2">Price</th>
            </tr>
          </thead>
          <tbody>
            {variants.map((v, i) => (
              <tr key={v.id || i} className="border-t border-[#EFE6D8]" data-testid={`admin-shop-variant-row-${i}`}>
                <td className="py-1.5 pr-2"><input type="checkbox" checked={v.enabled} onChange={(e) => update(i, "enabled", e.target.checked)} data-testid={`admin-shop-variant-enabled-${i}`} /></td>
                <td className="pr-2">{manual ? <input className={inputCls} value={v.label} onChange={(e) => update(i, "label", e.target.value)} data-testid={`admin-shop-variant-label-${i}`} /> : v.label}</td>
                <td className="pr-2">{manual ? <input className={inputCls} value={v.size} onChange={(e) => update(i, "size", e.target.value)} /> : v.size}</td>
                <td className="pr-2">{manual ? <input className={inputCls} value={v.color} onChange={(e) => update(i, "color", e.target.value)} /> : v.color}</td>
                <td className="pr-2 w-28"><input type="number" step="0.01" min="0" className={inputCls} value={v.price} onChange={(e) => update(i, "price", Number(e.target.value))} data-testid={`admin-shop-variant-price-${i}`} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {manual && (
        <button type="button" className={`${btn.ghost} mt-3`} onClick={() => onChange([...variants, { label: "", size: "", color: "", price: 0, enabled: true }])} data-testid="admin-shop-add-variant">
          Add option
        </button>
      )}
    </div>
  );
};
